import type { Evaluare, NotificareRecalcul } from "@/types/notificariRecalcul";

const TEXTE_MOTIV: Record<string, string> = {
  bilant_nou:
    "Bilanțul pentru un an mai recent este disponibil: recalculați încadrarea și analiza de risc",
  caen_schimbat:
    "Codurile CAEN au fost recodificate sau s-au schimbat: recalculați încadrarea și analiza de risc",
  stare_schimbata:
    "Starea firmei la Registrul Comerțului s-a schimbat: recalculați încadrarea și analiza de risc",
  lista_schimbata:
    "O listă oficială în care apare firma s-a actualizat: recalculați încadrarea și analiza de risc",
  dimensiune_schimbata:
    "Dimensiunea firmei s-a schimbat: recalculați încadrarea și analiza de risc",
  incadrare_schimbata:
    "Încadrarea estimată de platformă s-a schimbat: recalculați încadrarea și analiza de risc",
  grup_schimbat:
    "Componența grupului din care face parte firma s-a schimbat: recalculați încadrarea și analiza de risc",
};

const ETICHETE_ORIGINE: Record<string, string> = {
  platforma: "Estimare platformă",
  utilizator: "Evaluarea dumneavoastră",
  oficial: "Decizie DNSC",
};

export function textMotivRecalcul(motiv: string | null | undefined): string {
  if (!motiv) return "Datele firmei s-au schimbat: recalculați încadrarea";
  return (
    TEXTE_MOTIV[motiv] ?? "Datele firmei s-au schimbat: recalculați încadrarea"
  );
}

export function etichetaOrigineEvaluare(
  origine: string | null | undefined
): string {
  if (!origine) return "Necunoscut";
  return ETICHETE_ORIGINE[origine] ?? origine;
}

export function formateazaDataEvaluare(
  data: string | null | undefined
): string {
  if (!data) return "—";
  const d = new Date(data);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("ro-RO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function textVersiuneDate(evaluare: Evaluare): string {
  const versiune = evaluare.versiune_date ?? {};
  const bucati: string[] = [];
  const an = versiune["an_bilant"];
  if (typeof an === "number" || typeof an === "string")
    bucati.push(`bilanț ${an}`);
  const snapshot = versiune["snapshot_onrc"];
  if (typeof snapshot === "number") bucati.push(`ONRC #${snapshot}`);
  const liste = versiune["versiune_liste"];
  if (typeof liste === "number") bucati.push(`liste #${liste}`);
  const algoritm = versiune["versiune_algoritm"];
  if (typeof algoritm === "string") bucati.push(`algoritm ${algoritm}`);
  const numar = versiune["numar"];
  if (typeof numar === "string") bucati.push(`decizia ${numar}`);
  return bucati.length > 0 ? bucati.join(" · ") : "—";
}

export function notificariNecitite(
  notificari: NotificareRecalcul[] | undefined
): NotificareRecalcul[] {
  if (!notificari) return [];
  return notificari.filter((n) => !n.citit_la && !n.recalculat_la);
}
